import TicketHolderServiceError
    from "@/services/TicketHolderService/Errors/TicketHolderServiceError";
import {TicketHolder, TicketHolderData} from "@/services/TicketHolderService/types";
import {VendorTicketHolderDataResponse, VendorTicketHolderResponse} from "@bookingkit/api-v4";

const mapTicketHolderData = (data: VendorTicketHolderDataResponse) => {
    return {
        email: data?.email ?? '',
        firstName: data?.first_name ?? '',
        lastName: data?.last_name ?? '',
        dateOfBirth: data?.date_of_birth ? new Date(data?.date_of_birth) : null,
        streetName: data?.street_name ?? '',
        streetNumber: data?.street_number ?? '',
        city: data?.city ?? '',
        country: data?.country ?? '',
        zip: data?.zip ?? '',
    }
}
export const fromApiToTicketHolder = (apiResponse: VendorTicketHolderResponse): TicketHolder=> {
    const {id, ticket_id, data} = apiResponse;
    if (!id) {
        throw TicketHolderServiceError.fromMalformedResponse('id');
    }
    if (!ticket_id) {
        throw TicketHolderServiceError.fromMalformedResponse('ticket_id');
    }
    if (!data) {
        throw TicketHolderServiceError.fromMalformedResponse('data');
    }

    return {
        id: id,
        ticketId: ticket_id,
        data: mapTicketHolderData(data),
    };
};
